import { create } from "zustand";
import { useAuthStore } from "@/stores/auth-store";

export interface ComparisonState<T> {
  viewerId: string | null;
  items: T[];
  select: (viewerId: string, item: T) => void;
  remove: (id: string) => void;
  clear: () => void;
}

export function createComparisonStore<T extends { id: string; name: string }>() {
const useStore = create<ComparisonState<T>>((set) => ({
  viewerId: null,
  items: [],
  select: (viewerId, item) => set((state) => {
    const items = state.viewerId === viewerId ? state.items : [];
    if (items.some((p) => p.id === item.id) || items.length === 2) return state;
    return { viewerId, items: [...items, item] };
  }),
  remove: (id) => set((state) => ({ items: state.items.filter((p) => p.id !== id) })),
  clear: () => set({ viewerId: null, items: [] }),
}));

useAuthStore.subscribe((state, previous) => {
  if (state.status !== "authenticated" || state.profile?.sub !== previous.profile?.sub) {
    useStore.getState().clear();
  }
});

return useStore;
}
